export function getTemplatesSuccess(state, action) {
  return Object.assign({}, state, {
    payload: action.payload,
    loading: false,
    error: null,
  });
}
